import { render, staticRenderFns } from "./Macs.vue?vue&type=template&id=13022814&scoped=true&"
import script from "./Macs.vue?vue&type=script&lang=js&"
export * from "./Macs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13022814",
  null
  
)

export default component.exports